import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'

export const BASE_CLASS = `${PAGE_BASE_CLASS}-secondaryBar`

export const AD_ACTIONS_VARIANTS = {
  DETAIL: 'detail',
  GALLERY: 'gallery'
}
